<template>
  <main>
    <app-raster-legend
      ref="legend"
      :value="isActive && !isDynamicStyle"
      style="position: absolute; bottom: 50px; margin-left: 15px; z-index: 1;"
      layout="vertical" class="app-raster-legend"></app-raster-legend>

    <v-navigation-drawer app disable-resize-watcher hide-overlay mobile-break-point="0" :value="isActive" width="500">

      <v-container fluid class="pa-0">
        <v-layout row>
          <v-flex xs12>
            <v-toolbar flat extension-height="80">
              <v-toolbar-title>{{ $t('historico') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="$store.dispatch('disableControl')" :disabled="isLoading">
                <v-icon>close</v-icon>
              </v-btn>
                <v-toolbar-title slot="extension" style="margin: 0px auto; width: 100%;">
                  <v-layout row wrap>
                    <v-flex xs6 class="px-2">
                      <app-select-indicador
                        :disabled="isPlaying"></app-select-indicador>
                    </v-flex>
                    <v-flex xs6 class="px-2">
                      <app-select-period
                        :disabled="isPlaying"></app-select-period>
                    </v-flex>
                  </v-layout>
                </v-toolbar-title>
            </v-toolbar>

            <v-toolbar flat>
              <v-toolbar-title style="width: 100%;" class="mx-3">
                <div class="container-buttons">
                  <v-tooltip bottom>
                    <v-btn 
                      style="margin: 0px auto;" slot="activator" 
                      @click="isDynamicStyle = !isDynamicStyle" 
                      fab small :color="isDynamicStyle ? 'red darken-2' : 'blue darken-1'"
                      :disabled="isPlaying"
                    >
                      <v-icon>palette</v-icon>
                    </v-btn>
                    <span>Cambiar estilo</span>
                  </v-tooltip>
                </div>
              </v-toolbar-title>
            </v-toolbar>

            <!-- Diálogo para elegir el estilo de la capa raster -->
            <app-raster-filter
              ref="rasterFilter"
              :rasterLayer="LayerRaster" 
              :value="isDynamicStyle && isActive"></app-raster-filter>

            <v-card-text class="pb-0">

              <v-card class="my-3" :dark="!$store.getters.isDarkTheme" :light="$store.getters.isDarkTheme">

                <v-progress-linear height="5" :value="(loaded == 0 ? 0 : (100 * loading / loaded) | 0)" class="mb-0"></v-progress-linear>

                <v-card-text>

                  <v-select
                    :items="velocitiesKeys"
                    v-model="velocity"
                    solo
                    :background-color="`green ${$store.getters.isDarkTheme ? 'lighten-2' : 'darken-2'}`"
                    item-text="displayName"
                    prepend-inner-icon="slow_motion_video"
                    append-icon="keyboard_arrow_down" 
                    persistent-hint
                  ></v-select>

                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-subheader :light="$store.getters.isDarkTheme">{{$t('año')}}</v-subheader>
                    </v-flex>
                    <v-flex xs10>
                      <v-slider
                        :min="minYear"
                        :max="maxYear"
                        v-model="year"
                        :disabled="isPlaying"
                        :dark="!$store.getters.isDarkTheme" 
                        :light="$store.getters.isDarkTheme"
                        color="primary" class="my-0" hide-details
                        :thumb-label="true">
                      </v-slider>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap v-show="period == periodModes.MENSUAL">
                    <v-flex xs2>
                      <v-subheader :light="$store.getters.isDarkTheme">{{$t('mes')}}</v-subheader>
                    </v-flex>
                    <v-flex xs10>
                      <v-slider
                        :min="0"
                        :max="11"
                        v-model="month"
                        :disabled="isPlaying"
                        :dark="!$store.getters.isDarkTheme" 
                        :light="$store.getters.isDarkTheme"
                        color="primary" class="my-0" hide-details 
                        :thumb-label="true">
                      </v-slider>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap v-show="period == periodModes.TRIMESTRAL">
                    <v-flex xs2>
                      <v-subheader :light="$store.getters.isDarkTheme">{{$t('trimestre')}}</v-subheader>
                    </v-flex>
                    <v-flex xs10>
                      <v-slider
                        :min="0"
                        :max="3"
                        v-model="trim"
                        :disabled="isPlaying"
                        :dark="!$store.getters.isDarkTheme" :light="$store.getters.isDarkTheme"
                        color="primary" class="my-0" hide-details 
                        :thumb-label="true">
                      </v-slider>
                    </v-flex>
                  </v-layout>

                  <v-list :light="$store.getters.isDarkTheme">
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Histórico de {{indicador}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{raster ? raster.displayName : 'Sin datos'}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-spacer></v-spacer>

                      <v-list-tile-action>
                        <v-btn :disabled="!canGoBack || isPlaying" @click="handleDirection(directionModes.PREV)" icon :light="$store.getters.isDarkTheme">
                          <v-icon>fast_rewind</v-icon>
                        </v-btn>
                      </v-list-tile-action>

                      <v-list-tile-action :class="{ 'mx-3': $vuetify.breakpoint.mdAndUp }">
                        <v-btn 
                          :disabled="period == periodModes.ANUAL && yearsList.length <= 1"
                          @click="handlePlayerButton" icon :light="$store.getters.isDarkTheme">
                          <v-icon v-if="isPlaying">pause</v-icon>
                          <v-icon v-else-if="!isPlaying && canGoNext">play_arrow</v-icon>
                          <v-icon v-else>replay</v-icon>
                        </v-btn>
                      </v-list-tile-action>

                      <v-list-tile-action :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
                        <v-btn :disabled="!canGoNext || isPlaying" @click="handleDirection(directionModes.NEXT)" icon :light="$store.getters.isDarkTheme">
                          <v-icon>fast_forward</v-icon>
                        </v-btn>
                      </v-list-tile-action>

                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-card-text>

          </v-flex>
        </v-layout>
      </v-container>

    </v-navigation-drawer>
  </main>
</template>

<script>
import moment from 'moment'
import OlObservable from 'ol/observable'
import SourceTileWMS from 'ol/source/tilewms'

import AppSelectPeriod from '../utils/shared-components/select-period'
import AppSelectIndicador from '../utils/shared-components/select-indicador'
import AppRasterFilter from '../utils/shared-components/raster-range-filter'
import AppRasterLegend from '../utils/shared-components/raster-legend'

import getSortFunction from '../utils/sort'

import { LayerOrto, LayerRaster, LayerActuacion } from '../utils/layers'

import config from '@/config'

const geoserverURL = `${config.geoserver.geoserverURL}/wms`

const months = moment.localeData('es').months().map(m => m.toLowerCase())
const trims = ['primavera', 'verano', 'otoño', 'invierno']

export default {
  props: ['map'],

  components: {
    AppSelectPeriod,
    AppSelectIndicador,
    AppRasterFilter,
    AppRasterLegend
  },

  data() {
    return {
      id: 'Player-Historico',

      LayerRaster,

      year: null,
      month: null,
      trim: null,

      isPlaying: false,
      isDynamicStyle: false,

      /* Podemos verlo en 3 períodos */
      periodModes: {
        ANUAL: 'Anual',
        TRIMESTRAL: 'Trimestral',
        MENSUAL: 'Mensual'
      },

      velocities: {
        slow: 2400,
        medium: 1200,
        fast: 600
      },

      directionModes: {
        NEXT: 0,
        PREV: 1
      },

      velocity: 1200,

      loaded: 0,
      loading: 0
    }
  },

  computed: {

    raster: {
      get() { return this.$store.getters.raster },
      set(value) { this.$store.dispatch('setRaster', value) }
    },

    velocitiesKeys() {
      return Object.entries(this.velocities).map(([name, value]) => ({name, displayName: this.$t(`velocidad.${name}`) , value}))
    },

    period() {
      return this.$store.getters.period
    },

    periods() {
      return Object.values(this.periodModes)
    },

    activeControlId() {
      return this.$store.getters.activeControlId
    },
    
    isActive() {
      return (!!this.activeControlId) && this.activeControlId.startsWith(this.id)
    },

    isLoading: {
      get() {
        return this.$store.getters.isLoading
      },
      set(value) {
        this.$store.dispatch('setLoading', value)
      }
    },

    indicadores() {
      return Object.keys(this.$store.getters.indicadores)
        .map(str => str.charAt(0).toUpperCase() + str.slice(1))
    },

    indicador() {
      return this.$store.getters.indicador
    },

    rasters() {
      const indicadores = this.$store.getters.indicadores

      if(!indicadores[this.indicador] || !this.period) {
        return []
      }

      const period = this.period.toLowerCase()
      const layerNames  = indicadores[this.indicador]

      return layerNames
        .filter(({name}) => name.indexOf(period) > -1)
        .map(({name, nativeBoundingBox: { minx, maxx, miny, maxy} }) => 
          ({name: `${config.geoserver.geoserverWorkspace}:${name}`, url: geoserverURL, bounds: [minx, miny, maxx, maxy], displayName: this.getDisplayName(name) }))
        .sort(getSortFunction(this.period))
        .reverse()
    },

    rastersOfActualYear() {
      return this.rasters.filter(({name}) => name.endsWith(this.year.toString()))
    },

    yearsList() {
      const setYears = this.rasters.reduce((s, { name }) => {
        const [year] = name.match(/\d{4}/)
        s.add(+year)
        return s
      }, new Set([]))

      return [...setYears]
    },

    minYear() {
      return this.yearsList[0]
    },

    maxYear() {
      return this.yearsList[this.yearsList.length - 1]
    },

    years() {
      return this.rasters.filter(({ name }) => name.includes('anual'))
    },

    months() {
      const rasters = this.rastersOfActualYear
      // months == moment.months
      return months.map(m => rasters.find(({name}) => name.includes(m) ))
    },

    trims() {
      const rasters = this.rastersOfActualYear

      return trims.map(t => rasters.find(({name}) => name.includes(t) ))
    },

    canGoBack() {
      const index = this.yearsList.findIndex(y => y == this.year)
      const isFirstYear = index == 0

      switch(this.period) {
        case this.periodModes.ANUAL:
          return !isFirstYear && this.yearsList.length > 1
        break;
        case this.periodModes.MENSUAL:
          return !(isFirstYear && this.month == 0)
        break;
        case this.periodModes.TRIMESTRAL:
          return !(isFirstYear && this.trim == 0)
        break;
      }
    },

    canGoNext() {
      const index = this.yearsList.findIndex(y => y == this.year)
      const isLastYear = index == this.yearsList.length - 1

      switch(this.period) {
        case this.periodModes.ANUAL:
          return !isLastYear && this.yearsList.length > 1
        break;
        case this.periodModes.MENSUAL:
          return !(isLastYear && this.month == 11)
        break;
        case this.periodModes.TRIMESTRAL:
          return !(isLastYear && this.trim == 3)
        break;
      }
    }

  },

  methods: {
    checkControl(newControl, lastControl) {
      return newControl.startsWith(this.id) || lastControl.startsWith(this.id)
    },

    setRaster() {
      if(!this.raster) {
        return LayerRaster.setSource()
      }

      // console.log('setRaster Player')
      const { name: layers, url } = this.raster

      const source = new SourceTileWMS({ url, params: { layers }, crossOrigin: 'anonymous' })
      LayerRaster.setSource(source)
    },

    updateRaster() {
      switch(this.period) {
        case this.periodModes.ANUAL:
          const index = this.yearsList.findIndex(y => y == this.year)
          this.raster = this.years[index]
          break;
        case this.periodModes.MENSUAL:
          this.raster = this.months[this.month]
          break;
        case this.periodModes.TRIMESTRAL:
          this.raster = this.trims[this.trim]
          break;
      }     
    },

    handleDirection(direction) {
      // console.log('handle direction', direction)
      // Índice del año (Útil para todos los períodos)
      if ((direction == this.directionModes.NEXT && !this.canGoNext) ||
          (direction == this.directionModes.PREV && !this.canGoBack)) {
        return
      }

      switch(this.period) {
        case this.periodModes.ANUAL:
          this.year = this.year + (direction == this.directionModes.NEXT ? 1 : -1)
        break;
        case this.periodModes.MENSUAL:
          if(this.month == 11 && direction == this.directionModes.NEXT) {
            this.year++
            this.month = 0
            return
          }

          if(this.month == 0 && direction == this.directionModes.PREV) {
            this.year--
            this.month = 11
            return
          }

          this.month = this.month + (direction == this.directionModes.NEXT ? 1 : -1)
        break;
        case this.periodModes.TRIMESTRAL:
          if(this.trim == 3 && direction == this.directionModes.NEXT) {
            this.year++
            this.trim = 0
            return
          }

          if(this.trim == 0 && direction == this.directionModes.PREV) {
            this.year--
            this.trim = 3
            return
          }

          this.trim = this.trim + (direction == this.directionModes.NEXT ? 1 : -1)
        break;
      }
    },

    handlePlayerButton() {
      // Índice del año (Útil para todos los períodos)
      const index = this.yearsList.findIndex(y => y == this.year)
      const isLastYear = index == this.yearsList.length - 1

      if(!this.isPlaying) {
        switch(this.period) {
          case this.periodModes.ANUAL:
            // Si ha llegado al final se pausa
            if(isLastYear) {
              this.year = this.yearsList[0] - 1
              break;
            }
          break;
          case this.periodModes.MENSUAL:
            if(this.month == 11 && isLastYear) {
              this.year = this.yearsList[0]
              this.month = -1
            }
          break;
          case this.periodModes.TRIMESTRAL:
            if(this.trim == 3 && isLastYear) {
              this.year = this.yearsList[0]
              this.trim = -1
            }
          break;
        }
      }

      this.isPlaying = !this.isPlaying
    },

    waitForTiles() {
      return new Promise(resolve => {
        this.loading = 0
        this.loaded = 0

        this.$nextTick(() => {
          const source = LayerRaster.getSource()
  
          if(!source) {
            return resolve()
          }
    
          const tileLoadStart = () => {
            this.loading++
          }
    
          const tileLoadEnd = () => {
            this.loaded++
            if(this.loaded == this.loading) {
              source.un('tileloadstart', tileLoadStart)
              source.un(['tileloadend', 'tileloaderror'], tileLoadEnd)

              // this.loaded = this.loading = 0

              resolve()
            }
          }

          source.on('tileloadstart', tileLoadStart)
          source.on(['tileloadend', 'tileloaderror'], tileLoadEnd)
        })
  
      })
    },

    waitForVelocity() {
      // console.log(velocity, 'velocity', this.velocity)
      return new Promise(res => setTimeout(res, this.velocity))
    },

    async play() {
      if(!this.isPlaying) {
        return
      }
      
      // Índice del año (Útil para todos los períodos)
      const index = this.yearsList.findIndex(y => y == this.year)
      const isLastYear = index == this.yearsList.length - 1
      
      switch(this.period) {
        case this.periodModes.ANUAL:
          // Si ha llegado al final se pausa
          if(isLastYear) {
            return (this.isPlaying = false)
          }

          this.year++

        break;
        case this.periodModes.MENSUAL:
          if(this.month == 11) {
            if(isLastYear) {
              return (this.isPlaying = false)
            }

            this.year++
            this.month = 0
            break
          }

          this.month++
        break;
        case this.periodModes.TRIMESTRAL:
          if(this.trim == 3) {
            if(isLastYear) {
              return (this.isPlaying = false)
            }

            this.year++
            this.trim = 0
            break
          }

          this.trim++
        break;
      }

      await Promise.all([this.waitForTiles(), this.waitForVelocity()])
      requestAnimationFrame(this.play.bind(this))
    },

    getDisplayName(name) {
      return name
        .replace(this.indicador + '_', '')
        .replace(this.period.toLowerCase() + '_', '')
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    },

    setKeyboardEnabled() {
        const listenerKeyboard = e => {
          if(e.repeat) {
            return e.preventDefault()
          }
          
          const keyCode = e.which || e.keyCode
          
          switch(keyCode) {
            case 32: this.handlePlayerButton(); break;
            case 37: !this.isPlaying && this.handleDirection(this.directionModes.PREV); break;
            case 39: !this.isPlaying && this.handleDirection(this.directionModes.NEXT); break;
          }
        }

        document.body[this.isActive ? 'addEventListener' : 'removeEventListener']('keydown', listenerKeyboard)

    }
  },

  watch: {
    isDynamicStyle(dynamic) {
      if(!dynamic) {
        this.setRaster()
      }
    },

    isPlaying(playing) {
      this.loaded = this.loading = 0

      if(playing) {
        this.play()
      }
    },

    year() {
      if(this.period == this.periodModes.ANUAL) {
        const index = this.yearsList.findIndex(y => y == this.year)
        this.raster = this.years[index]
        return
      }

      this.updateRaster()
    },

    month() {
      this.raster = this.months[this.month]
    },

    trim() {
      this.raster = this.trims[this.trim]
    },

    raster() {
      if(this.isActive && !this.isDynamicStyle) {
        this.setRaster()
      }
    },

    indicador() {
      if(this.isActive) {
        this.updateRaster()
      }
    },

    period() {
      if(this.isActive) {
        this.updateRaster() 
      }
    },

    activeControlId(newControl, lastControl) {

      if(!this.checkControl(newControl || '', lastControl || '')) {
        return
      }

      this.setRaster()
      this.setKeyboardEnabled()
      
      this.isActive && this.$parent.fitIntoProjectExtent()

      this.isPlaying = false
      this.isDynamicStyle = false

      this.map.getLayers().forEach(layer => layer.setVisible(!this.isActive))

      ;[LayerOrto, LayerRaster, LayerActuacion]
        .forEach(layer => layer.setMap(this.isActive ? this.map : null))
    },

  }
}
</script>

<style>
.container-buttons {
  display: flex;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// Player.vue?2d4cf934